import api from "./Api";

class VendedorEmailService {
  GetVendedorEmail(payload) {
    return api.get("/v1/vendedorEmail/" + payload).then((response) => {
      return response.data;
    });
  }

  PostVendedorEmail(payload) {
    return api.post("/v1/vendedorEmail/", payload).then((response) => {
      return response.data;
    });
  }

  PutVendedorEmail(payload) {
    return api.put("/v1/vendedorEmail/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteVendedorEmail(payload) {
    return api.delete("/v1/vendedorEmail/" + payload).then((response) => {
      return response.data;
    });
  }

  GetVendedorEmailOData(payload) {
    return api.get("/OData/VendedorEmail" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new VendedorEmailService();
